/* eslint-disable */
import { combineReducers } from 'redux';

// Constants Types
import {
  PATIENT_ENROLLMENT_REQUEST,
  PATIENT_ENROLLMENT_SUCCESS,
  PATIENT_ENROLLMENT_FAILURE,
  PATIENT_SEARCH_REQUEST,
  PATIENT_SEARCH_SUCCESS,
  PATIENT_SEARCH_FAILURE,
  PATIENT_SEARCH_CLEAR,
  PATIENT_SEARCH_IDENTIFIERS,
  PATIENT_SEARCH_ALL_DATA_CLEAR,
  FETCH_ENROLLED_PATIENT_REQUEST,
  FETCH_ENROLLED_PATIENT_SUCCESS,
  FETCH_ENROLLED_PATIENT_FAILURE,
  FETCH_ENROLLED_INSURANCE_SUCCESS,
  FETCH_ENROLLED_ADDRESS_SUCCESS,
  FETCH_ENROLLED_OVERVIEW_SUCCESS,
  NEW_PATIENT_ENROLL_FORM,
  UPDATE_DUATION_REQUEST,
  UPDATE_DUATION_SUCCESS,
  UPDATE_DUATION_FAILURE,
} from './types';

const initialState = {
  isRequesting: false,
  isSearching: false,
  isFetchingEnrolledData: false,
  searchResult: [],
  searchIdentifiers: {},
  enrolledPatientData: {},
  enrolledInsuranceData: {},
  enrolledAddressData: {},
  enrolledOverviewData: {},
  enrollEditMode: false,
  showPatientForm: false,
  showResultScreen: false,
  error: {},
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PATIENT_ENROLLMENT_REQUEST]: (state, action) => ({
    ...state,
    isRequesting: true,
  }),
  [PATIENT_ENROLLMENT_SUCCESS]: (state, action) => ({
    ...state,
    isRequesting: false,
  }),
  [PATIENT_ENROLLMENT_FAILURE]: (state, action) => ({
    ...state,
    isRequesting: false,
    error: action.payload,
  }),
  [PATIENT_SEARCH_REQUEST]: (state, action) => ({
    ...state,
    isSearching: true,
  }),
  [PATIENT_SEARCH_SUCCESS]: (state, action) => ({
    ...state,
    isSearching: false,
    showResultScreen: true,
    searchResult: action.payload,
  }),
  [PATIENT_SEARCH_FAILURE]: (state, action) => ({
    ...state,
    isSearching: false,
    searchResult: [],
     error: action.payload,
  }),
  [PATIENT_SEARCH_CLEAR]: (state, action) => ({
    ...state,
    showPatientForm: false,
    searchResult: [],
  }),
  [PATIENT_SEARCH_ALL_DATA_CLEAR]: (state, action) => ({
    ...state,
    isRequesting: false,
    isSearching: false,
    showResultScreen: false,
    searchResult: [],
    searchIdentifiers: {},
    showPatientForm: false,
    enrollEditMode: false,
    error: {},
  }),
  [PATIENT_SEARCH_IDENTIFIERS]: (state, action) => ({
    ...state,
    searchIdentifiers: action.payload,
  }),
  [FETCH_ENROLLED_PATIENT_REQUEST]: (state, action) => ({
    ...state,
    isFetchingEnrolledData: true,
  }),
  [FETCH_ENROLLED_PATIENT_SUCCESS]: (state, action) => ({
    ...state,
    enrolledPatientData:  action.payload,
  }),
  [FETCH_ENROLLED_ADDRESS_SUCCESS]: (state, action) => ({
    ...state,
    enrolledAddressData:  action.payload,
  }),
  [FETCH_ENROLLED_INSURANCE_SUCCESS]: (state, action) => ({
    ...state,
    enrolledInsuranceData:  action.payload,
  }),
  [FETCH_ENROLLED_OVERVIEW_SUCCESS]: (state, action) => ({
    ...state,
    isFetchingEnrolledData: false,
    enrollEditMode: true,
    showPatientForm: true,
    enrolledOverviewData:  action.payload,
  }),
  [FETCH_ENROLLED_PATIENT_FAILURE]: (state, action) => ({
    ...state,
    isFetchingEnrolledData: false,
    error: action.payload,
  }),
  [NEW_PATIENT_ENROLL_FORM]: (state, action) => ({
    ...state,
    showPatientForm: true,
    searchResult: [],
    enrolledPatientData: {},
    enrolledInsuranceData: {},
    enrolledAddressData: {},
    enrollEditMode: false,
    enrolledOverviewData: {},
  }),
  [UPDATE_DUATION_REQUEST]: (state, action) => ({
    ...state,
    isRequesting: true,
  }),
  [UPDATE_DUATION_SUCCESS]: (state, action) => ({
    ...state,
    isRequesting: false,
  }),
  [UPDATE_DUATION_FAILURE]: (state, action) => ({
    ...state,
    isRequesting: false,
    error: action.payload,
  }),
};

//
// Reducer
// ------------------------------------
const PatientEnrollment = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};

export default combineReducers({
  patientEnrollment: PatientEnrollment,
});



// WEBPACK FOOTER //
// ./src/views/state/PatientEnrollment/PatientEnrollmentReducers.js